import { useEffect } from 'react';
import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ZerodayBreadthPopout } from '../components/zeroday-breadth/ZerodayBreadthWidget';

/** Zeroday Breadth in its own window. */
export function ZerodayBreadthPopoutPage(): ReactElement {
  const { windowId = '' } = useParams<{ windowId: string }>();

  useEffect(() => {
    document.title = 'Zeroday Breadth';
  }, []);

  return (
    <div className="h-screen w-screen bg-dark-bg flex flex-col">
      <ZerodayBreadthPopout popoutId={windowId} />
    </div>
  );
}
